<template>
  <div class="app">
    <!-- 底  -->
    <footer class="footer">
      <div class="footer01">
        <div class="footer02">
          <div class="footer05">1391 0303 798</div>
          <div class=footer03>
            <img :src="require('../assets/img/f01.png')" alt="名企科技logo" />
          </div>
          <div class=footer04>
            <img :src="require('../assets/img/wx.png')" width="95" height="95" alt="微信二维码" />
            <br>
            微信扫码咨询
          </div>
        </div>

        <div>
          <div style="display:flex;text-align: left;">
            <div class="title001">
              <div class="title002">
                主营业务
              </div>
              <div>
                <div class="dijuzhong">
                  <div style="padding:5px;cursor: pointer;" @click="pathJizhang">代理记账</div>
                  <div style="padding:5px;cursor: pointer;" @click="pathgongshang">工商服务</div>
                </div>
                <div class="dijuzhong">
                  <div style="padding:5px;cursor: pointer;" @click="pathshuiwu">税务服务</div>
                  <div style="padding:5px;cursor: pointer;" @click="pathzhichan">知识产权</div>
                </div>
                <div class="dijuzhong">
                  <div style="padding:5px;cursor: pointer;" @click="pathxuke">资质许可</div>
                  <div style="padding:5px;cursor: pointer;" @click="pathrenshi">人事社保</div>
                </div>
                <div class="dijuzhong">
                  <div style="padding:5px;cursor: pointer;" @click="pathgongshang">变更注销</div>
                  <div style="padding:5px;cursor: pointer;" @click="pathgongshang">增资减资</div>
                </div>
                <div class="dijuzhong">
                  <div style="padding:5px;cursor: pointer;" @click="pathgongshang">注册地址</div>
                  <div style="padding:5px;cursor: pointer;" @click="pathgongshang">代办执照</div>
                </div>
              </div>
            </div>
            <div class="title003">
              <div class="title002">
                联系我们
              </div>
              <div>
                <div style="padding:5px;cursor: pointer;" @click="pathabout">关于我们</div>
                <div style="padding:5px;cursor: pointer;" @click="pathcontact">联系我们</div>
                <div><img class="lianxi" src="../assets/img/wx.png" alt="联系微信"></div>
              </div>
            </div>
            <div class="title004">
              <div class="title002">
                友情链接
              </div>
              <div>
                <div class="dijuzhong">
                  <div style="padding:5px;"><a href="http://bjmqkj.com/" class="white-link" target="_blank">名企科技官</a>
                  </div>
                  <div style="padding:5px;"><a href="#小程序://财务助手/QwLDo4jsxNFC1FC" class="white-link"
                      target="_blank">名企小程序</a>
                  </div>
                </div>
                <div class="dijuzhong">
                  <div style="padding:5px;"><a
                      href="https://www.toutiao.com/c/user/token/MS4wLjABAAAAgCqkZkdzQUlKBWI-7U810KqJ24kGZbPIpL9bt8nYEYI/?"
                      class="white-link" target="_blank">名企头条号</a></div>
                  <div style="padding:5px;"><a href="https://www.chinatax.gov.cn/" class="white-link"
                      target="_blank">国家税务局</a></div>
                </div>
                <div class="dijuzhong">
                  <div style="padding:5px;"><a href="https://weibo.com/u/6124656174" class="white-link"
                      target="_blank">名企微博号</a></div>
                  <div style="padding:5px;"><a href="https://www.samr.gov.cn/index.html" class="white-link"
                      target="_blank">国家监督局</a></div>
                </div>
                <div class="dijuzhong">
                  <div style="padding:5px;"><a
                      href="https://mp.sohu.com/profile?xpt=NkRFRTE1MDg3QTk0QTZDRUQ5MkZEQzczMDcwNjBENTRAcXEuc29odS5jb20=&scm=1019.20005.0.0.0&spm=smpc.csrpage.suggest-list.1.1737508231718HwpxCwu"
                      class="white-link" target="_blank">名企搜狐号</a></div>
                  <div style="padding:5px;"><a href="https://www.gov.cn/" class="white-link" target="_blank">中国政府网</a>
                  </div>
                </div>
                <div class="dijuzhong">
                  <div style="padding:5px;"><a href="https://www.zhihu.com/people/beijingmingqikeji" class="white-link"
                      target="_blank">名企知乎号</a></div>
                  <div style="padding:5px;"><a href="https://rsj.beijing.gov.cn/zmhd/" class="white-link"
                      target="_blank">人事社保局</a></div>
                </div>
              </div>

            </div>
          </div>
          <div class="di">
            <span>地址：北京西城区西直门外大街1号院2号楼19C2</span> <br>
            北京名企科技有限公司 代理记账丨工商注册 | 社保托管 <br> Copyright © 2017 - 2025 <span><a href="https://beian.miit.gov.cn/"
                target="_blank" title="京ICP备17073936号" class="huise-link">京ICP备17073936号</a></span>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>
  
<script>
export default {
  name: 'Footer',
  data() {
    return {
    }
  },
  methods: {
    pathue() {
      this.$router.push('/wangEditor');
    },
    pathRemen() {
      this.$router.push('/remen')
    },
    pathIndex() {
      this.$router.push('/');
    },
    pathCompanyReg() {
      this.$router.push('/zhuce')
    },
    pathJizhang() {
      this.$router.push('/jizhang')
    },
    pathgongshang() {
      this.$router.push('/gongshang')
    },
    pathshuiwu() {
      this.$router.push('/shuiwu');
    },
    pathzhichan() {
      this.$router.push('/zhichan')
    },
    pathxuke() {
      this.$router.push('/xuke')
    },
    pathrenshi() {
      this.$router.push('/renshi')
    },
    pathxueyuan() {
      this.$router.push('/xueyuan');
    },
    pathabout() {
      this.$router.push('/about')
    },
    pathcontact() {
      this.$router.push('/contact')
    },
  }
}
</script>
  
<style>
.el-menu.el-menu--horizontal {
  border-bottom: none !important;
}

.el-carousel__button {
  background-color: #000 !important;
}

.el-menu-item.is-active {
  background-color: #b30101 !important;
}

.el-menu--horizontal>.el-menu-item {
  float: left;
  height: 45px !important;
  line-height: 45px !important;
  margin: 0;
}

@media (max-width: 768px) {
  .responsive-carousel el-carousel el-carousel--horizontal {
    width: 100%;
  }

  .el-carousel__indicators el-carousel__indicators--horizontal {
    margin-top: 15px !important
  }

  .el-pager li {
    padding: 0 0px !important;
    min-width: 25.5px !important;
  }

  .el-menu--horizontal>.el-menu-item {
    height: 30px !important;
    line-height: 30px !important;
  }

}
</style>
  
  
<style scoped>
/* 底 */
.footer {
  height: 340px;
  background: #1d1d1d;
  margin-top: 32px;
}

.footer01 {
  width: 1110px;
  margin: 0 auto;
}

.footer02 {
  float: left;
  width: 187px;
  color: #fff;
  height: 340px;
  background: #d22525;
  text-align: center;
  line-height: 24px;
}

.footer03 {
  padding-top: 24px;
}

.footer04 {
  padding-top: 40px;
  font-size: 12px;
}

.footer05 {
  padding-top: 40px;
  color: white;
  font-weight: 700;
  font-size: 23px;
}

.white-link {
  color: white;
  text-decoration: none;
}

.di {
  margin-top: 15px;
  padding: 8px;
  font-size: 14px;
  color: white;
  line-height: 20px;
}

.title001 {
  padding: 8px;
  font-size: 16px;
  color: white;
  width: 280px;
  text-align: center;
}

.title003 {
  padding: 8px;
  font-size: 16px;
  color: white;
  width: 280px;
  text-align: center;
}

.lianxi {
  width: 30%;
}

.title004 {
  padding: 8px;
  font-size: 16px;
  color: white;
  width: 280px;
  text-align: center;
}

.title002 {
  border-bottom: 3px solid #d22525;
  font-weight: 700;
  padding-top: 15px;
  padding-bottom: 5px;
  margin-bottom: 15px;
  text-align: center;
}

.dijuzhong {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  font-size: 14px;
}

.lianjie {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: left;
}

.kaoyou {
  padding: 5px;
}

.huise-link {
  color: white;
  text-decoration: none;
}

@media (max-width: 768px) {

  /* 底 */
  .footer {
    height: 250px;
    background: #1d1d1d;
    font-size: 0.5rem;
    margin-top: 2vh;
  }

  .footer01 {
    width: 100%;
    margin: 0 auto;
  }

  .footer02 {
    display: none;
  }

  .footer03 {
    display: none;
  }

  .footer04 {
    display: none;
  }

  .footer05 {
    position: relative;
    float: right;
    width: 100%;
    background: url(../assets/img/f03.png) no-repeat 547px 155px;
  }

  .white-link {
    color: white;
    text-decoration: none;
  }

  .huise-link {
    color: white;
    text-decoration: none;
  }

  .di {
    text-align: text;
    font-size: 9px;
    color: white;
    width: 100%;
    margin-top: 2px;
    /* padding-top:0px; */
    padding-left: 0px;
    padding-right: 0px;
    padding-bottom: 33px;
    line-height: normal;
  }

  .title001 {
    padding: 2px;
    font-size: 13px;
    color: white;
    width: 33%;
  }

  .title003 {
    padding: 2px;
    font-size: 13px;
    color: white;
    width: 30%;
  }

  .title004 {
    padding: 2px;
    font-size: 13px;
    color: white;
    width: 36%;
  }

  .lianxi {
    width: 42%;
  }


  .title002 {
    border-bottom: 3px solid #d22525;
    font-weight: 700;
    padding-top: 10px;
    padding-left: 3px;
    padding-right: 3px;
    padding-bottom: 5px;
    margin-bottom: 10px;
  }

  .dijuzhong {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    font-size: 9px;
  }

  .kaoyou {
    padding: 5px;
    flex: 1;
    text-align: center;
  }
}
</style>
  


// WEBPACK FOOTER //
// src/components/Footer.vue